import React, { Component } from 'react';
import { connect } from 'react-redux';
import Step from '@axa-asia/emma-stylesheet/lib/components/Step/Step';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import { isApp, resolveLocalizedText } from '../../../../utils';
import { goto } from '../../../../actions/historyActions';
import { getInsuredAccessLabels } from '../../selectors/insuredAccessSelector';
import './style.scss';

export interface DeactivateAccessContainerProps {
  insuredAccessLabels: any;
}

export interface DeactivateAccessContainerState {}

export class DeactivateAccessContainer extends Component<
  DeactivateAccessContainerProps,
  DeactivateAccessContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    const { insuredAccessLabels } = this.props;
    const { pageTitle, deactivationTitle, gotItBtn, deactivationStepContext } =
      insuredAccessLabels;

    return (
      <div className="deactivate-access emma-stylesheet-grid-system">
        {!isApp() && (
          <CustomerProfileTitle
            customerTitle={pageTitle ? resolveLocalizedText(pageTitle) : ''}
          />
        )}
        <div className="deactivation-header">
          {deactivationTitle ? resolveLocalizedText(deactivationTitle) : ''}
        </div>
        <div className="step-wrapper">
          <Step
            context={
              deactivationStepContext
                ? resolveLocalizedText(deactivationStepContext)
                : ''
            }
          />
        </div>
        <div className="btn-wrapper">
          <button
            data-enable-ga
            data-ga-type="button"
            className="emma-stylesheet-primary-default-button"
            onClick={() => {
              goto('emma-customer-profile/insuredaccess');
            }}
          >
            {gotItBtn ? resolveLocalizedText(gotItBtn) : ''}
          </button>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any) {
    const insuredAccessLabels = getInsuredAccessLabels(state);

    return {
      insuredAccessLabels,
    };
  }

  static mapDispatchToProps() {
    return {};
  }
}

export default connect(
  DeactivateAccessContainer.mapStateToProps,
  DeactivateAccessContainer.mapDispatchToProps,
)(DeactivateAccessContainer);
